if(!customElements.get('custom-testimonials')){
    class CustomTestimonials extends HTMLElement {
        constructor(){
            super();
    
            this.init();
        }

        init(){
            this.swiperContainer = this.querySelector('.swiper-container');
            this.initSwiper();
        }
    
        initSwiper(){
            var totalSlides = parseInt(this.swiperContainer.dataset.totalSlides);
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView);
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
    
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;
    
            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    500: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    991: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    1200: {
                        slidesPerView: slidesPerView
                    }
                },
                observer: true,
                observeSlideChildren: true
            }
    
            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                el: this.querySelector('.swiper-pagination')
                }
            }
    
            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev')
                }
            }
    
            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }
    
            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
            this.checkPagination();

            this.swiper.on('resize' ,() => {
                this.checkPagination();
                if(this.swiperContainer.dataset.navStyle == 'number'){
    
                    this.updateNumberedPagination();
    
                }
            })
    
            if(this.swiperContainer.dataset.navStyle == 'number'){
    
                this.updateNumberedPagination();
                
                this.swiper.on('realIndexChange', () => {
                    var currentIdx = this.swiper.realIndex + 1;
                    if(this.querySelector('.swiper-pagination--number')){
                        this.querySelector('.swiper-pagination--number .current-slide').innerHTML = currentIdx;
                    }
                })
            }
        }


        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }
    
        updateNumberedPagination(){
            if(this.swiperContainer.querySelectorAll(".swiper-pagination-bullet").length > 1){
                this.swiperContainer.querySelector('.swiper-pagination--number').setAttribute('data-hidden', 'false');
                this.swiperContainer.querySelector('.swiper-pagination--number .total-slides').innerHTML = this.swiperContainer.querySelectorAll(".swiper-pagination-bullet").length;
            }else{
                this.swiperContainer.querySelector('.swiper-pagination--number').setAttribute('data-hidden', 'true');
            }
        }

        refresh(){
            this.initSwiper();
        }
    }
    
    customElements.define('custom-testimonials', CustomTestimonials);
}